/* eslint-disable global-require */
import Config from 'config';
import { Vue } from 'vue-infra';
import { TABS } from '@/common/consts';

const MyConnectionsPage = r => require.ensure([], () => r(require('@/components/my-connections/my-connections-page.vue')), 'MyConnectionsPage');
const AllConnectionsPage = r => require.ensure([], () => r(require('@/components/all-connections/all-connections-page.vue')), 'AllConnectionsPage');
const AgentListPage = r => require.ensure([], () => r(require('@/components/agent-list/agent-list-page.vue')), 'AgentListPage');
const MainLayout = r => require.ensure([], () => r(require('@/components/layout/main-layout.vue')), 'MainLayout');


const routes = [{
  path: `/aw/${TABS.MY_CONNECTIONS}/:id?`,
  name: TABS.MY_CONNECTIONS,
  components: { aw: MyConnectionsPage },
  meta: { layout: MainLayout },
}, {
  path: `/aw/${TABS.ALL_CONNECTIONS}`,
  name: TABS.ALL_CONNECTIONS,
  components: { aw: AllConnectionsPage },
  props: { aw: true },
  meta: { layout: MainLayout },
  beforeEnter(to, from, next) {
    const store = new Vue().$store;
    const hasMessagingHistoryPrivilege = store.getters['session/getUserPrivilegeById']('1713');
    const hasViewActiveConnections = store.getters['session/getUserPrivilegeById']('1734');
    const isLPA = store.getters['session/getConfig']().isLPA;
    if (isLPA || (hasMessagingHistoryPrivilege && hasViewActiveConnections)) {
      next();
    } else {
      next(false);
    }
  },
}, {
  path: `/aw/${TABS.AGENT_LIST}`,
  name: TABS.AGENT_LIST,
  components: { aw: AgentListPage },
  meta: { layout: MainLayout },
}, {
  path: '/aw/*',
  name: 'default',
  redirect: { path: `/${Config.applicationName}/${TABS.MY_CONNECTIONS}` },
  meta: { layout: MainLayout },
}];

export default routes;
